import React, { useCallback } from 'react';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { CollapsibleListSectionCollapsedContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content/collapsed-content';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';

import style from './orders-sidebar-section.module.less';

/**
 * @param {object} props
 * @param {ReactNode} [props.collapsedSectionContent]
 * @param {boolean} props.isExpanded
 * @param {(isExpanded: boolean) => void} props.toggleIsExpanded
 * @param {object} [props.dragHandleProps]
 * @param {ReactNode} props.sectionContent
 * @param {ReactNode} props.headerContent
 * @param {ReactNode} [props.summaryData]
 * @param {string} [props.summaryDataStyle]
 * @returns {JSX.Element}
 */
export const OrdersSidebarSection = ({
  collapsedSectionContent,
  isExpanded,
  toggleIsExpanded,
  dragHandleProps,
  sectionContent,
  headerContent,
  summaryData,
  summaryDataStyle,
}) => {
  const onClickHeader = useCallback(
    (e) => {
      if (!e?.defaultPrevented) {
        toggleIsExpanded(isExpanded);
      }
    },
    [toggleIsExpanded, isExpanded],
  );

  return (
    <CollapsibleListSection className={style['order-sidebar-section']} open={isExpanded}>
      <CollapsibleListSectionHeader
        caretClassName={style['order-sidebar-section-caret']}
        className={style['orders-sidebar-section-header']}
        contentClassName={style['orders-sidebar-section-header-content']}
        dragHandleProps={dragHandleProps}
        grabberIconClassName={style['order-sidebar-section-grabber-icon']}
        onClick={onClickHeader}
        summaryData={summaryData}
        summaryDataStyle={summaryDataStyle}
      >
        {headerContent}
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>{sectionContent}</CollapsibleListSectionContent>
      {collapsedSectionContent ? (
        <CollapsibleListSectionCollapsedContent>{collapsedSectionContent}</CollapsibleListSectionCollapsedContent>
      ) : (
        // This needs to be a fragment as opposed to false or null because of the way the <CollapsibleListSection> is written
        React.Fragment
      )}
    </CollapsibleListSection>
  );
};
